// utils/numeroALetras.js

const numeroALetras = (numero, moneda = 'Colones') => {
  // Validar que sea un número válido
  if (typeof numero !== 'number' || isNaN(numero)) {
    return `CERO ${moneda.toUpperCase()}`;
  }

  // Manejar decimales de forma más precisa
  const numeroString = numero.toFixed(2); // Forzar 2 decimales
  const [parteEnteraStr, parteDecimalStr] = numeroString.split('.');
  
  const parteEntera = parseInt(parteEnteraStr, 10);
  const decimales = parseInt(parteDecimalStr, 10);

  // Convertir parte entera
  let textoEntero = convertirParteEntera(parteEntera);
  
  // Siempre agregar los decimales y la moneda
  textoEntero += ` ${moneda.toUpperCase()} CON ${decimales.toString().padStart(2, '0')}/100`;

  return textoEntero;
};

const convertirParteEntera = (value) => {
  if (value === 0) return "CERO";
  if (value === 1) return "UN";
  if (value === 2) return "DOS";
  if (value === 3) return "TRES";
  if (value === 4) return "CUATRO";
  if (value === 5) return "CINCO";
  if (value === 6) return "SEIS";
  if (value === 7) return "SIETE";
  if (value === 8) return "OCHO";
  if (value === 9) return "NUEVE";
  if (value === 10) return "DIEZ";
  if (value === 11) return "ONCE";
  if (value === 12) return "DOCE";
  if (value === 13) return "TRECE";
  if (value === 14) return "CATORCE";
  if (value === 15) return "QUINCE";
  if (value < 20) return "DIECI" + convertirParteEntera(value - 10);
  if (value === 20) return "VEINTE";
  if (value < 30) return "VEINTI" + convertirParteEntera(value - 20);
  if (value === 30) return "TREINTA";
  if (value === 40) return "CUARENTA";
  if (value === 50) return "CINCUENTA";
  if (value === 60) return "SESENTA";
  if (value === 70) return "SETENTA";
  if (value === 80) return "OCHENTA";
  if (value === 90) return "NOVENTA";
  if (value < 100) return convertirParteEntera(Math.floor(value / 10) * 10) + " Y " + convertirParteEntera(value % 10);
  if (value === 100) return "CIEN";
  if (value < 200) return "CIENTO " + convertirParteEntera(value - 100);
  if (value === 200 || value === 300 || value === 400 || value === 600 || value === 800) {
    return convertirParteEntera(Math.floor(value / 100)) + "CIENTOS";
  }
  if (value === 500) return "QUINIENTOS";
  if (value === 700) return "SETECIENTOS";
  if (value === 900) return "NOVECIENTOS";
  if (value < 1000) return convertirParteEntera(Math.floor(value / 100) * 100) + " " + convertirParteEntera(value % 100);
  if (value === 1000) return "MIL";
  if (value < 2000) return "MIL " + convertirParteEntera(value % 1000);
  if (value < 1000000) {
    const miles = Math.floor(value / 1000);
    const resto = value % 1000;
    let texto = convertirParteEntera(miles) + " MIL";
    if (resto > 0) texto += " " + convertirParteEntera(resto);
    return texto;
  }
  if (value === 1000000) return "UN MILLON";
  if (value < 2000000) return "UN MILLON " + convertirParteEntera(value % 1000000);
  if (value < 1000000000000) {
    const millones = Math.floor(value / 1000000);
    const resto = value % 1000000;
    let texto = convertirParteEntera(millones) + " MILLONES";
    if (resto > 0) texto += " " + convertirParteEntera(resto);
    return texto;
  }
  if (value === 1000000000000) return "UN BILLON";
  if (value < 2000000000000) return "UN BILLON " + convertirParteEntera(value % 1000000000000);
  
  const billones = Math.floor(value / 1000000000000);
  const resto = value % 1000000000000;
  let texto = convertirParteEntera(billones) + " BILLONES";
  if (resto > 0) texto += " " + convertirParteEntera(resto);
  return texto;
};

export default numeroALetras;